/**
 * @author sgdh
 * @description 销售中心枚举
 */
import * as func from '@/func'
import { enumToListV, type SelectTypeTm } from '@/func/enumToMap'
// 书单管理枚举--------------------------------------------
//书单状态
export enum BookStatus {
  DRAFT = 0,
  PENDING_REVIEW = 1,
  CANCELED = 2,
  REJECTED = 3,
  REVIEW = 4,
  PENDING_RELEASE = 5,
  PUBLISHED = 6,
  EFFECTIVE = 7,
  ISSUED = 8,
  EXPIRED = 9,
}

export enum BookStatusName {
  DRAFT = '草稿',
  PENDING_REVIEW = '待生效',
  CANCELED = '已生效',
  REJECTED = '已过期',
  REVIEW = '已作废',
  PENDING_RELEASE = '已下发',
  PUBLISHED = '待审批',
  EFFECTIVE = '已取消',
  ISSUED = '已拒绝',
  EXPIRED = '已审核',
}
export enum BookStatusColor {
  DRAFT = 'blue',
  PENDING_REVIEW = 'pink',
  CANCELED = 'green',
  REJECTED = 'cyan',
  REVIEW = 'red',
  PENDING_RELEASE = 'magenta',
  PUBLISHED = 'volcano',
  EFFECTIVE = 'purple',
  ISSUED = 'red',
  EXPIRED = 'lime',
}
//书单类型
export enum BookType {
  ORDINARY_BOOK = 0,
  // PAVILION_MATCHING_BOOK = 1,
}

export enum BookTypeName {
  ORDINARY_BOOK = '普通书单',
  // PAVILION_MATCHING_BOOK = '馆配书单',
}
//书单标签
export enum BookLabel {
  LABEL_BOOK = 0,
  LABEL_NEW_BOOK = 1,
  LABEL_SPECIAL_BOOK = 2,
}

export enum BookLabelName {
  LABEL_BOOK = '普通标签',
  LABEL_NEW_BOOK = '新书标签',
  LABEL_SPECIAL_BOOK = '专题标签',
}
// 活动管理枚举--------------------------------------------
// 查询方式枚举
export enum QueryMethod {
  MY = 1,
  SYSTEM = 2,
}

export enum QueryMethodName {
  MY = '我的活动',
  SYSTEM = '系统活动',
}

// 活动状态
export enum ActivityStatus {
  DRAFT = 0,
  PENDING_REVIEW = 1,
  PENDING_RELEASE = 2,
  PUBLISHED = 3,
  EXPIRED = 4,
  REJECTED = 5,
  VOIDED = 6,
}

export enum ActivityStatusName {
  DRAFT = '草稿',
  PENDING_REVIEW = '待审核',
  PENDING_RELEASE = '待发布',
  PUBLISHED = '已发布',
  EXPIRED = '已过期',
  REJECTED = '已拒绝',
  VOIDED = '已作废',
}

export enum ActivityStatusColor {
  DRAFT = '#fb9856',
  PENDING_REVIEW = '#1677ff',
  PENDING_RELEASE = '#1677ff',
  PUBLISHED = '#1677ff',
  EXPIRED = '#ff4d4f',
  REJECTED = '#ff4d4f',
  VOIDED = '#fb9856',
}

// 活动类型
export enum ActivityType {
  SUBSCRIPTION = 1,
  COLLEGE_AND_UNIVERSITY = 2,
  LIBRARY_MATCHING = 3,
}

export enum ActivityTypeName {
  SUBSCRIPTION = '征订活动',
  COLLEGE_AND_UNIVERSITY = '大中专活动',
  LIBRARY_MATCHING = '馆配活动',
}

// 学期
export enum Semester {
  LAST = 1,
  NEXT = 2,
}

export enum SemesterName {
  LAST = '上学期',
  NEXT = '下学期',
}

// 预付方式
export enum PrepaidMethod {
  ADVANCE_PAYMENT = 1,
  ONE_TIME_PAYMENT = 2,
}

export enum PrepaidMethodName {
  ADVANCE_PAYMENT = '预付',
  ONE_TIME_PAYMENT = '单次付清',
}

// 邮寄方式
export enum Mailing {
  UNIFIED = 1,
  ORDER = 2,
}

export enum MailingName {
  UNIFIED = '统一配送',
  ORDER = '按单邮寄',
}

// 邮费收取
export enum PostageCollect {
  FREE_SHIPPING = 1,
  SCHOOL_PAYMENT = 2,
  PERSONAL_PAYMENT = 3,
}

export enum PostageCollectName {
  FREE_SHIPPING = '免邮',
  SCHOOL_PAYMENT = '学校支付',
  PERSONAL_PAYMENT = '个人支付',
}

// 已开启未开启-
export enum NotOrActivated {
  NOT = 1,
  ACTIVATED = 2,
}

export enum NotOrActivatedName {
  NOT = '未开启',
  ACTIVATED = '已开启',
}

// 审批状态
export enum ApprovalStatus {
  PENDING_REVIEW = 0,
  REVIEW = 1,
  REJECTED = 2,
  CANCELED = 3,
}

export enum ApprovalStatusName {
  PENDING_REVIEW = '待审核',
  REVIEW = '已审核',
  REJECTED = '已拒绝',
  CANCELED = '已取消',
}

// 发送内容
export enum EmailContent {
  ELECTRONIC_LIST = 1,
  CATALOG_DATA = 2,
}

export enum EmailContentName {
  ELECTRONIC_LIST = '电子清单',
  CATALOG_DATA = '编目数据',
}

// 文件类型
export enum EmailFileType {
  XLSX = 1,
  ISO = 2,
}

export enum EmailFileTypeName {
  XLSX = '.xlsx',
  ISO = '.iso',
}

// 是否需要-
export enum NeedOrNot {
  NOT = 0,
  NEED = 1,
}

export enum NeedOrNotName {
  NOT = '不需要',
  NEED = '需要',
}

// 销售订单管理--教材事业部-----------------
// 查询方式枚举
export enum TBSMQueryMethod {
  ORDER = 1,
  BREED = 2,
}

export enum TBSMQueryMethodName {
  ORDER = '按订单',
  BREED = '按品种',
}

// 业务属性枚举
export enum BusinessAttributes {
  MIDDLE_SCHOOL_SALES = 1,
  VOCATIONAL_COLLEGE_TEXTBOOKS = 2,
}

export enum BusinessAttributesName {
  MIDDLE_SCHOOL_SALES = '中小学教材',
  VOCATIONAL_COLLEGE_TEXTBOOKS = '大中专教材',
}

// 订单状态枚举
export enum OrderType {
  CREATE_NEW = 1,
  PENDING_REVIEW = 2,
  REJECTED = 3,
  APPROVED = 4,
  // PENDING = 5,
  CANCELED = 5,
  CLOSED = 6,
}

export enum OrderTypeName {
  CREATE_NEW = '新建',
  PENDING_REVIEW = '待审核',
  REJECTED = '已驳回',
  APPROVED = '已审核',
  // PENDING = '挂起',
  CANCELED = '已取消',
  CLOSED = '已关闭',
}

// 履约状态枚举
export enum PerformanceType {
  NOT_START = 1,
  NO_NEED,
  TO_BE_NOTIFIED,
  PARTIAL_NOTIFICATION,
  NOTIFIED,
  PARTIAL_SHIPMENT,
  SHIPMENT,
  PARTIAL_RECEIPT,
  RECEIPT,
  COMPLETED,
  TERMINATED,
}
// 1.未开始、2.无需履约、3.待通知、4.部分通知、5.已通知、6.部分发货、7.已发货、8.部分收货、9.已收货、10.已完成、11.已终止
export enum PerformanceTypeName {
  NOT_START = '未开始',
  NO_NEED = '无需履约',
  TO_BE_NOTIFIED = '待通知',
  PARTIAL_NOTIFICATION = '部分通知',
  NOTIFIED = '已通知',
  PARTIAL_SHIPMENT = '部分发货',
  SHIPMENT = '已发货',
  PARTIAL_RECEIPT = '部分收货',
  RECEIPT = '已收货',
  COMPLETED = '已完成',
  TERMINATED = '已终止',
}
export enum PerformanceTypeColor {
  NOT_START = 'pink',
  NO_NEED = 'red',
  TO_BE_NOTIFIED = 'orange',
  PARTIAL_NOTIFICATION = 'green',
  NOTIFIED = 'cyan',
  PARTIAL_SHIPMENT = 'blue',
  SHIPMENT = 'magenta',
  PARTIAL_RECEIPT = 'volcano',
  RECEIPT = 'lime',
  COMPLETED = 'blue',
  TERMINATED = 'purple',
}
export const PerformanceTypeStatus: SelectTypeTm[] = enumToListV(PerformanceType)
// 挂起状态
export enum PendingStatus {
  NOT = 0,
  FULL_ORDER = 2,
  PARTIAL = 1,
}

export enum PendingStatusName {
  NOT = '未挂起',
  FULL_ORDER = '整单挂起',
  PARTIAL = '部分挂起',
}

// 订单标识
export enum OrderSign {
  ORDINARY = 1,
  URGENT = 2,
  // STRAIGHT_HAIR = 3,
  // ONE_PIECE = 4,
  // ON_DEMAND = 5,
  // ON_ORDER = 6,
  // PURCHASE = 6,
  SELF_PICKUP = 7,
}
// 1-普通订单 2-急件订单 3-直发订单 4-一件代发 5-按需发货 6-按单发货 7-自提订单

export enum OrderSignName {
  ORDINARY = '普通订单',
  URGENT = '急件订单',
  // STRAIGHT_HAIR = '直发订单',
  // ONE_PIECE = '一件代发',
  // ON_DEMAND = '按需发货',
  // ON_ORDER = '按单发货',
  // PURCHASE = '采购意向订单',
  SELF_PICKUP = '自提订单',
}
//订单标识-创建销售订单
export enum OrderSaleSign {
  ORDINARY = 1,
  URGENT = 2,
  SELF_PICKUP = 7,
}

export enum OrderSaleSignName {
  ORDINARY = '普通订单',
  URGENT = '急件订单',
  SELF_PICKUP = '自提',
}

// 满足规则  1.整单一次性满足放单、2.单品满足放单、3.单品部分满足部分放单
export enum MeetRules {
  ALL = 1,
  LINE = 2,
  LINE_PART = 3,
}

export enum MeetRulesName {
  ALL = '整单一次性满足放单',
  LINE = '单品满足放单',
  LINE_PART = '单品部分满足部分放单',
}

// 报订形式
export enum SubscriptionForm {
  PAPER = 1,
  FAX,
  PHONE,
  DIRECTORY,
  MAIN_DISTRIBUTION,
  PERSON,
  ELECTRONIC,
  OTHER,
}

export enum SubscriptionFormName {
  PAPER = '纸质',
  FAX = '传真',
  PHONE = '电话',
  DIRECTORY = '目录',
  MAIN_DISTRIBUTION = '主配',
  PERSON = '来人',
  ELECTRONIC = '电子',
  OTHER = '其他',
}

// 配送方式
export enum DeliveryMethod {
  EXPRESS_DELIVERY = 1,
  SELF_PICKUP = 2,
  SELF_DELIVERY = 3,
  IMMEDIATE = 4,
}

export enum DeliveryMethodName {
  EXPRESS_DELIVERY = '快运/快递',
  SELF_PICKUP = '自提',
  SELF_DELIVERY = '自配送',
  IMMEDIATE = '卖场即时',
}

// 配送方式省店
export enum DeliveryMethodProvincial {
  SELF_PICKUP = 1,
  EXPRESS_DELIVERY = 2,
  SELF_DELIVERY = 3,
  IMMEDIATE = 4,
  FLASH_DELIVERY = 5,
}

export enum DeliveryMethodProvincialName {
  EXPRESS_DELIVERY = '快运/快递',
  SELF_PICKUP = '自提',
  SELF_DELIVERY = '自配送',
  IMMEDIATE = '即时配送',
  FLASH_DELIVERY = '闪送',
}

// 发货类型
export enum ShipmentMethod {
  SELF_INITIATED = 1,
  PROVINCIAL_DISPATCH = 2,
  SUPPLIER_DISPATCH = 3, //2024-12-20.临时隐藏
}

export enum ShipmentMethodName {
  SELF_INITIATED = '自发',
  PROVINCIAL_DISPATCH = '省店代发',
  SUPPLIER_DISPATCH = '供应商一键代发',
}

// 折扣、结算时间的缺省方式
export enum DefaultMethod {
  DIRECTORY = 1,
  CONTRACT = 2,
}

export enum DefaultMethodName {
  DIRECTORY = '继承目录',
  CONTRACT = '继承合同',
}

// 教材销售管理 -- 中小学
export enum SecondarySchoolsOrderType {
  NORMAL_ORDER = '普通订单', // 普通订单
  URGENT_ORDER = '急件订单', // 急件订单
  DIRECT_SHIPMENT = '直发订单', // 直发订单
  ON_DEMAND_SHIPMENT = '按需发货', // 按需发货
  ORDER_BY_ORDER = '按单发货', // 按单发货
  PROCUREMENT_INTENT_ORDER = '采购意向订单', // 采购意向订单
}

// 发货方式枚举
export enum SecondarySchoolsDeliveryMethod {
  SELF_SHIP = '自发', // 自发
  // PROVINCIAL_STORE_DISTRIBUTION = '省店代发', // 省店代发
  // SUPPLIER_ONE_KEY_DISTRIBUTION = '供应商一键代发', // 供应商一键代发      2024-12-20.临时隐藏
}

//满足方式
export enum SecondarySchoolsFulfillmentType {
  FULL_ORDER = '整单满足',
  LINE_SATISFIED = '单行满足',
  PARTIAL_LINE_SATISFIED = '单行部分满足',
}

// 配送方式
export enum SecondarySchoolsDeliveryType {
  EXPRESS_COURIER = '快运/快递',
  SELF_PICKUP = '自提',
  SELF_DELIVERY = '自配送',
  INSTANT_MARKET = '卖场即时',
}

// 详情 序号
// 定义序号类型的枚举
export enum SecondarySchoolsKeyType {
  SINGLE = 1, // 单序号
  MULTIPLE, // 多序号
}

// 定义序号的录入类型枚举
export enum SecondarySchoolsSerialType {
  SEQUENTIAL = 1, // 按顺序
  RANGE, // 按序号范围
}

// 步骤条
export enum SecondarySchoolsStep {
  FIRST_STEP,
  SECOND_STEP,
  THIRD_STEP,
}

// 订单状态
export enum SecondarySchoolsStatus {
  BASE_ORDER_CREATION = 'BaseOrder', // 销售单创建--基订
  IMPORT_ORDER_CREATION = 'ImportOrder', // 报订单创建--导入订数
}

// 生成采购需求单
export enum SecondarySchoolOrderType {
  NORMAL_ORDER, // 普通订单
  URGENT_ORDER, // 急件订单
  DIRECT_SHIP_ORDER, // 直发订单
}

// 书单/目录
export enum ContentsListTitle {
  CATALOG_MANAGEMENT = 'CATALOG_MANAGEMENT', // 目录管理
  SMALL_DIRECTORY = 'SMALL_DIRECTORY', // 小目录管理
  CATALOG_RELEASE='CATALOG_RELEASE',//目录发布
}

// 目录列表操作类型
export enum DirectoryOpType {
  UNIFIED_COMPILATION = '统编',
  REWRITE_AGAIN = '再编',
  COPY = '复制',
  ENABLE = '启用',
  RELEASE = '发布',
  REVOKE_PUBLICATION = '撤销发布',
  INVENTORY_INITIALIZATION = '备货初始化',
  INVENTORY_INPUT = '备货录入',
  STOP_USING = '停用',
  DELETE = '删除',
  UNLOCK = '解锁',
  LOCKING = '锁定',
}

// 大目录状态下拉 目录状态
export enum DirectoryStatusSelect {
  TO_BE_SECTIONS = 0,
  DIV_INTO_SECTIONS = 1,
  // TO_BE_UNIFIED = 2,
  UNIFIED_COMPILATIO = 3,
  TO_BE_ISSUED = 4,
  ISSUED = 5,
  // REORGANIZED = 6,
  // TO_BE_INIT = 7,
  // ALREADY_INIT = 8,
  STOP_USING = 9,
  EXPIRED = 10,
  // COMP_EDITING = 11,
}

export enum DirectoryStatusSelectName {
  TO_BE_SECTIONS = '待分编',
  DIV_INTO_SECTIONS = '分编中',
  // TO_BE_UNIFIED = '待统编',
  UNIFIED_COMPILATIO = '统编中',
  TO_BE_ISSUED = '待下发',
  ISSUED = '已下发',
  // REORGANIZED = '再编中',
  // TO_BE_INIT = '待初始化',
  // ALREADY_INIT = '已初始化',
  STOP_USING = '停用',
  EXPIRED = '已过期',
  // COMP_EDITING = '已完成编辑',
}
export enum DirectoryStatusSelectColor {
  TO_BE_SECTIONS = 'magenta',
  DIV_INTO_SECTIONS = 'red',
  TO_BE_UNIFIED = 'volcano',
  UNIFIED_COMPILATIO = 'orange',
  TO_BE_ISSUED = 'gold',
  ISSUED = 'lime',
  REORGANIZED = 'green',
  TO_BE_INIT = 'cyan',
  ALREADY_INIT = 'blue',
  STOP_USING = 'blue',
  EXPIRED = 'green',
  COMP_EDITING = 'green',
}
// 购销形式：0经销、1寄售
export enum EnSellPurchaseType {
  SELL = 0,
  CONSIGNMENT = 1,
}
export enum EnSellPurchaseTypeName {
  SELL = '经销',
  CONSIGNMENT = '寄售',
}
// 循环教材：0非循环教材、1循环教材
export enum EnIfLoopTextbook {
  CYCLE = 0,
  NOT_CYCLE = 1,
}
export enum EnIfLoopTextbookName {
  CYCLE = '非循环教材',
  NOT_CYCLE = '循环教材',
}
export enum EnIfLoopTextbookType {
  非循环教材 = 0,
  循环教材 = 1,
}
export const EnIfLoopTextbookStatus: SelectTypeTm[] = enumToListV(EnIfLoopTextbookType)
// 循坏比例：0-5%、1-10%、2-15%、3-20%、4-25%、5-30%、6-35%、7-40%
export enum EnLoopRate {
  W = 0,
  YS = 1,
  YW = 2,
  ES = 3,
  EW = 4,
  SS = 5,
  SW = 6,
  SIS = 7,
}
export enum EnLoopRateName {
  W = '5%',
  YS = '10%',
  YW = '15%',
  ES = '20%',
  EW = '25%',
  SS = '30%',
  SW = '35%',
  SIS = '40%',
}
export enum EnLoopRateType {
  W = '0',
  YS = '1',
  YW = '2',
  ES = '3',
  EW = '4',
  SS = '5',
  SW = '6',
  SIS = '7',
}
export enum EnLoopRateTypeName {
  W = '5%',
  YS = '10%',
  YW = '15%',
  ES = '20%',
  EW = '25%',
  SS = '30%',
  SW = '35%',
  SIS = '40%',
}
export enum EnLoopRateTypeStatus {
  '5%' = '0',
  '10%' = '1',
  '15%' = '2',
  '20%' = '3',
  '25%' = '4',
  '30%' = '5',
  '35%' = '6',
  '40%' = '7',
}
export const EnLoopRateStatus: SelectTypeTm[] = enumToListV(EnLoopRateTypeStatus)

export enum EnPriority {
  P_1 = 1,
  P_2 = 2,
  P_3 = 3,
}

// 优先级
export enum EnPriorityName {
  P_1 = '高',
  P_2 = '中',
  P_3 = '低',
}

// 小目录状态下拉
export enum SmallDirectoryStatusSelect {
  DRAFT = 0,
  TO_BE_ISSUED = 1,
  ISSUED = 2,
  STOP_USING = 3,
  EXPIRED = 4,
}

// 小目录状态下拉name
export enum SmallDirectoryStatusSelectName {
  DRAFT = '草稿',
  TO_BE_ISSUED = '待下发',
  ISSUED = '已下发',
  STOP_USING = '已停用',
  EXPIRED = '已过期',
}

export enum SmallDirectoryStatusSelectColor {
  DRAFT = 'magenta',
  TO_BE_ISSUED = 'red',
  ISSUED = 'volcano',
  STOP_USING = 'orange',
  EXPIRED = 'green',
}

// 小目录锁定状态
export enum EnLockedState {
  LOCKED = 0,
  NOT_LOCKED = 1,
}

// 小目录锁定状态name
export enum EnLockedStateName {
  LOCKED = '锁定',
  NOT_LOCKED = '未锁定',
}

// 销售中心商店类型
export enum EnStoreTypes {
  PROVINCIAL_STORE = 0,
  GRASSROOTS_STORES = 1,
}

// 销售中心商店类型name
export enum EnStoreTypesName {
  PROVINCIAL_STORE = '省店',
  GRASSROOTS_STORES = '基层店',
}

// 二级业务属性
export enum BizAttrTypeSubOptions {
  PRIMARY_AND_SECONDARY_SCHOOLS = 1,
  JUNIOR_COLLEGE = 2,
  TEACHING_ASSISTANCE = 3,
  CHILD = 4,
}

export enum BizAttrTypeSubOptionsName {
  PRIMARY_AND_SECONDARY_SCHOOLS = '中小学',
  JUNIOR_COLLEGE = '大中专',
  TEACHING_ASSISTANCE = '教辅',
  CHILD = '幼儿',
}

// 一级业务属性
export enum BizAttrTypeOptions {
  TEACHING_MATERIAL = 1,
  // 目前一级业务属性只有教材
  // E_COMMERCE = 2,
  READING = 3,
  // LIBRARY_FACILITIES = 4,
  // INNOVATION = 5,
}

export enum BizAttrTypeOptionsName {
  TEACHING_MATERIAL = '教材',
  E_COMMERCE = '电商',
  READING = '阅读',
  LIBRARY_FACILITIES = '馆配',
  INNOVATION = '创新',
}
// 分编组状态状态下拉0待认领，1分编中，2已完成
export enum EnClassificationStatus {
  TO_BE_CLAIMED = 0,
  DIVIDED_INTO_SECTIONS = 1,
  COMPLETED = 2,
}

export enum EnClassificationStatusName {
  TO_BE_CLAIMED = '待认领',
  DIVIDED_INTO_SECTIONS = '分编中',
  COMPLETED = '已完成',
}

// 小目录下拉
export enum ContentsCatalog {
  MY_CATALOG = 0, // 我的目录
  ALL_DIRECTORIES = 1, // 全部目录
}

export enum ContentsCatalogName {
  MY_CATALOG = '我的目录', // 我的目录
  ALL_DIRECTORIES = '全部目录', // 全部目录
}

// 主配订单枚举---------------
// 主配类型
export enum MainDistributionType {
  MAIN_MATCH_SALES = 1,
  NEW_PRODUCT_PRE_ALLOCATION = 2,
}

export enum MainDistributionTypeName {
  MAIN_MATCH_SALES = '主配销售',
  NEW_PRODUCT_PRE_ALLOCATION = '新品预分',
}

// 主配订单业务属性枚举
export enum MDBusinessAttributes {
  LIBRARY_SUPPLY = 1,
  INNOVATION = 2,
  BOOKS = 3,
}

export enum MDBusinessAttributesName {
  LIBRARY_SUPPLY = '馆配',
  INNOVATION = '创新',
  BOOKS = '图书',
}

// 订单标识
export enum MDOrderSign {
  ORDINARY = 1,
  URGENT = 2,
  SELF_PICKUP = 3,
}

export enum MDOrderSignName {
  ORDINARY = '普通订单',
  URGENT = '急件订单',
  SELF_PICKUP = '自提',
}

// 配送方式
export enum MDDeliveryMethod {
  EXPRESS_DELIVERY = 1,
  SELF_PICKUP = 2,
  SELF_DELIVERY = 3,
}

export enum MDDeliveryMethodName {
  EXPRESS_DELIVERY = '快运/快递',
  SELF_PICKUP = '自提',
  SELF_DELIVERY = '自配送',
}

// 订单状态
export enum MDOrderStatus {
  DRAFT = 1,
  PENDING_APPROVAL = 2,
  PENDING_CONFIRMATION = 3,
  PARTIALLY_CONFIRMED = 4,
  EFFECTIVE = 5,
  REJECTED = 6,
  CLOSED = 7,
}

export enum MDOrderStatusName {
  DRAFT = '创建中',
  PENDING_APPROVAL = '待审批',
  PENDING_CONFIRMATION = '待确认',
  PARTIALLY_CONFIRMED = '部分确认',
  EFFECTIVE = '已生效',
  REJECTED = '已驳回',
  CLOSED = '已关闭',
}

// 业务模式
export enum BusinessModel {
  WHOLESALE = 1,
  GROUP_BUYING = 2,
  RETAIL = 3,
}

export enum BusinessModelName {
  WHOLESALE = '批发',
  GROUP_BUYING = '团购',
  RETAIL = '零售',
}

// 订单放单规则
export enum OrderReleaseRules {
  FULL_ORDER = 1,
  SINGLE_LINE = 2,
  PARTIAL = 3,
}

export enum OrderReleaseRulesName {
  FULL_ORDER = '整单满足放单',
  SINGLE_LINE = '单行满足放单',
  PARTIAL = '部分满足放单',
}

// 教材退货管理枚举---------------
// 退货状态
export enum ReturnStatus {
  // DRAFT = 1,
  // PENDING_REVIEW = 2,
  // REVOKED = 3,
  // TO_BE_RECEIVED = 4,
  // RETURNED = 5,
  // REJECTED = 6,
  // TO_BE_SUBMITTED = 7,
  // VOID = 8,
  DRAFT_INIT_FAILURE = 1, // 草稿
  PENDING_REVIEW = 2, // 待审核
  REJECTED = 3, // 已驳回（审核失败）
  APPROVED = 4, // 已审核
  CANCELLED = 5, // 已取消
  CLOSED = 6, // 已关闭
  // SUSPENDED = 5, // 挂起
  // CANCELLED = 6, // 已取消
  // CLOSED = 7, // 已关闭
}

export enum ReturnStatusName {
  // DRAFT = '草稿',
  // PENDING_REVIEW = '待审核',
  // REVOKED = '已撤销',
  // TO_BE_RECEIVED = '待收货',
  // RETURNED = '已退货',
  // REJECTED = '已拒绝',
  // TO_BE_SUBMITTED = '待提交',
  // VOID = '已作废',
  DRAFT_INIT_FAILURE = '草稿',
  PENDING_REVIEW = '待审核',
  REJECTED = '已驳回（审核失败）',
  APPROVED = '已审核',
  // SUSPENDED = '挂起',
  CANCELLED = '已取消',
  CLOSED = '已关闭',
}
export enum ReturnStatusColor {
  DRAFT_INIT_FAILURE = 'pink',
  PENDING_REVIEW = 'red',
  REJECTED = 'orange',
  APPROVED = 'green',
  CANCELLED = 'cyan',
  CLOSED = 'blue',
}

// 审核状态
export enum ExamineStatus {
  UNDER_REVIEW = 0,
  AUDITED = 1,
  CANCELED = 2,
  REJECTED = 3,
}

export enum ExamineStatusName {
  UNDER_REVIEW = '审核中',
  AUDITED = '已审核',
  CANCELED = '已取消',
  REJECTED = '已拒绝',
}

// 退货方式--下拉选择框，字段类型为枚举，必填项，值集：按期号、按书号、按片区、按客户、按班级、按个人；
// 退货方式（1、书号，2 ，期号，3，片区，4，客户，5班级，6个人
export enum ReturnWay {
  BOOK = 1,
  ISSUE,
  DISTRICT,
  CUSTOMER,
  CLASS,
  INDIVIDUAL,
}

export enum ReturnWayName {
  ISSUE = '按期号',
  BOOK = '按书号',
  DISTRICT = '按片区',
  CUSTOMER = '按客户',
  CLASS = '按班级',
  INDIVIDUAL = '按个人',
}

// 订单状态（1.草稿/初始化失败)、2.待审核、3.已驳回（审核失败）、4.已审核、5.挂起、6.已取消、7.已关闭
export enum RefundOrderStatus {
  草稿 = 1,
  待审核,
  已驳回,
  已审核,
  挂起,
  已取消,
  已关闭,
}

// 预单管理----
export enum EducationLevel {
  COLLEGE = 1, // 大中专
  PRIMARY_SECONDARY, // 中小学
  WHOLESALE_GROUP_BUYING, // 批发团购
}

// 普通订单
export enum FilterType {
  BY_ORDER = 1,
  BY_CUSTOMER = 2,
  BY_VARIETY = 3,
  BY_INVENTORY = 4,
}

export enum FilterTypeName {
  BY_ORDER = '按订单',
  BY_CUSTOMER = '按客户',
  BY_VARIETY = '按品种',
  BY_INVENTORY = '按库存',
}

// 预放单明细列表------------
export enum OrderReleaseType {
  ALL_FULFILL = 1, // 整单一次性满足放单
  SINGLE_FULFILL = 2, // 单品满足放单
  PARTIAL_FULFILL = 3, // 单品部分满足部分放单
}

export enum OrderReleaseTypeName {
  ALL_FULFILL = '整单一次性满足放单',
  SINGLE_FULFILL = '单品满足放单',
  PARTIAL_FULFILL = '单品部分满足部分放单',
}

// 贸易类型
export enum TradeType {
  DOMESTIC = 1,
  CROSS_BORDER = 2,
}

export enum TradeTypeName {
  DOMESTIC = '国内贸易',
  CROSS_BORDER = '跨境贸易',
}

// 预放订单 订单标识
export enum bookingOrderSign {
  ORDINARY = 1,
  URGENT,
  STRAIGHT_HAIR,
  DROP_SHIPPING,
  ON_DEMAND_SHIPMENT,
  ORDER_SPECIFIC_SHIPMENT,
  SELF_PICKUP,
}
export enum bookingOrderSignName {
  ORDINARY = '普通订单',
  URGENT = '急件订单',
  STRAIGHT_HAIR = '直发订单',
  DROP_SHIPPING = '一件代发',
  ON_DEMAND_SHIPMENT = '按需发货',
  ORDER_SPECIFIC_SHIPMENT = '按单发货',
  SELF_PICKUP = '自提订单',
}

// 折扣方向
export enum DiscountDirection {
  POSITIVE = 1,
  NEGATIVE = 2,
}
export enum DiscountDirectionName {
  POSITIVE = '正向',
  NEGATIVE = '逆向',
}

// 折扣类型
export enum DiscountType {
  FIXED = 1,
  DIRECT = 2,
}
export enum DiscountTypeName {
  FIXED = '固定',
  DIRECT = '顺加',
}

// 行类型
export enum ProductLineType {
  REGULAR_PRODUCT = 1,
  GIFT = 2,
}
export enum ProductLineTypeName {
  REGULAR_PRODUCT = '普通商品',
  GIFT = '赠品',
}

// 结算方式
export enum SettlementMethod {
  Credit = 1, // 赊账
  Cash = 2, // 现结
  Internal = 3, // 内部结算
}
export enum SettlementMethodName {
  Credit = '赊账', // 赊账
  Cash = '现结', // 现结
  Internal = '内部结算', // 内部结算
}
// 预放订单-履约状态枚举
export enum PreamplifierPerformanceType {
  NOT_STARTED = 1,
  NO_NEED = 2,
  TO_BE_NOTIFIED = 3,
  // PLACING_THE_ORDER = 4,
  PARTIAL_NOTIFICATION = 4,
  NOTIFIED = 5,
  PARTIAL_SHIPMENT = 6,
  SHIPMENT = 7,
  PARTIAL_RECEIPT = 8,
  RECEIPT = 9,
  COMPLETED = 10,
  TERMINATED = 11,
}
export enum PreamplifierPerformanceTypeName {
  NOT_STARTED = '未开始',
  NO_NEED = '无需履约',
  TO_BE_NOTIFIED = '待通知',
  // PLACING_THE_ORDER = '放单中',
  PARTIAL_NOTIFICATION = '部分通知',
  NOTIFIED = '已通知',
  PARTIAL_SHIPMENT = '部分发货',
  SHIPMENT = '已发货',
  PARTIAL_RECEIPT = '部分收货',
  RECEIPT = '已收货',
  COMPLETED = '已完成',
  TERMINATED = '已终止',
}

// Combination identifier (1. parent order, 2. child order)
export enum CombinationIdentifier {
  PARENT_ORDER = 1,
  CHILD_ORDER = 2,
}
export enum CombinationIdentifierName {
  PARENT_ORDER = '父单',
  CHILD_ORDER = '子单',
}

/**
 * 功能：类型 0 院系，1年级，2学年学期
 */
export enum MapType {
  院系 = 0,
  年级 = 1,
  学年 = 2,
}

export enum productRule {
  ORDER_FULLFILLMENT = 1,
  SINGLE_ITEM_FULFILLMENT = 2,
  PARTIAL_SINGLE_ITEM_FULFILLMENT = 3,
}
export enum productRuleName {
  ORDER_FULLFILLMENT = '整单一次性满足放单',
  SINGLE_ITEM_FULFILLMENT = '单品满足放单',
  PARTIAL_SINGLE_ITEM_FULFILLMENT = '单品部分满足部分放单',
}

/**
 * 功能：定价维度(1-按公司、2-按销售组、3-按店铺)
 */
export enum MapPriceDimension {
  按公司 = 1,
  按销售组 = 2,
  按店铺 = 3,
}
export const ListPriceDimension: SelectTypeTm[] = enumToListV(MapPriceDimension)
/**
 * 功能：单据状态(1-创建中、2-待审批、3-已审批、4-已驳回、5-已关闭)
 */
export enum MapState {
  创建中 = 1,
  待审批 = 2,
  已审批 = 3,
  已驳回 = 4,
  已关闭 = 5,
}
/**
 *  功能：单据状态颜色(1-blue、2-lime、3-green、4-red、5-orange)
 */
export enum MapStateColor {
  'blue' = 1,
  'purple' = 2,
  'green' = 3,
  'red' = 4,
  'orange' = 5,
}
export const ListState: SelectTypeTm[] = enumToListV(MapState)

/**
 * 功能：使用状态(1-启用、2-禁用)
 */
export enum MapUseState {
  启用 = 1,
  禁用 = 2,
}
export enum MapUseColor {
  'blue' = 1,
  'red' = 2,
}
export const ListUseState: SelectTypeTm[] = enumToListV(MapUseState)

/**
 * 功能：组合标识
 */
export enum MapAssembly {
  组合父项 = 0,
  组合子项 = 1,
}

/**
 * 功能：币种
 */
export enum MapPaymentCurrency {
  人民币 = 0,
}

/**
 * 功能：销售定价
 */
export enum MapLimitedCustomer {
  不限客户 = 1,
  限定客户 = 2,
  限定片区 = 3,
}

/**
 * 功能：店铺，临时定义写死，后续走字典或接口
 */
export enum MapShop {
  天猫 = 1,
  京东 = 2,
}
export const ListShop: SelectTypeTm[] = enumToListV(MapShop)

// 销售折扣功能枚举----------------------
// 折扣类型（1-固定折扣、2-顺加折扣）
export enum MapDiscountType {
  固定折扣 = 1,
  顺加折扣,
}
export const ListDiscountType: SelectTypeTm[] = enumToListV(MapDiscountType)

// 折扣维度(1-按公司、2-按销售组、3-按店铺)
export enum MapDiscountDimension {
  按公司 = 1,
  按销售组,
  按店铺,
}
export const ListDiscountDimension: any = enumToListV(MapDiscountDimension)
// 限定客户(、1-限定客户 2 限定片区)
export enum MapDpLimitedCustomer {
  限定客户 = 1,
  限定片区,
}
export const ListDpLimitedCustomer: SelectTypeTm[] = enumToListV(MapDpLimitedCustomer)
// 限定商品(1-限定商品、2-限定目录期号、3-限定书单、4-限定类目)
export enum MapLimitedProduct {
  限定商品 = 1,
  限定目录期号,
  限定书单,
  限定类目,
}
export const ListLimitedProduct: SelectTypeTm[] = enumToListV(MapLimitedProduct)

export enum isFreeType {
  是 = 0,
  否 = 1,
}
export const isFreeStatus: SelectTypeTm[] = enumToListV(isFreeType)

//单据状态 Document Status
export enum DocumentStatus {
  DRAFT = 1,
  PENDING_APPROVAL = 2,
  EFFECTIVE = 3,
  REJECTED = 4,
  CLOSED = 5,
}

export enum DocumentStatusName {
  DRAFT = '创建中',
  PENDING_APPROVAL = '待审批',
  EFFECTIVE = '已审批',
  REJECTED = '已驳回',
  CLOSED = '已关闭',
}
//生效状态Effective status
export enum EffectiveStatus {
  EFFECT = 1,
  NOEFFECT = 2,
}
export enum EffectiveStatusName {
  EFFECT = '已生效',
  NOEFFECT = '未生效',
}
/**
 * 修改tags的样式，加上颜色
 */
export enum EffectiveStatusColor {
  EFFECT = 'blue',
  NOEFFECT = 'red',
}

//商品类型
export enum ProductType {
  BOOKS = 1,
  BOOKSNO = 2,
  COMBINATION = 3,
  PROCESSING = 4,
  COUPONS = 5,
  SERVE = 6,
  DUMMY = 7,
}
export enum ProductTypeName {
  BOOKS = '图书',
  BOOKSNO = '非图',
  COMBINATION = '组合',
  PROCESSING = '加工',
  COUPONS = '卡券',
  SERVE = '服务',
  DUMMY = '虚拟',
}
// 订单类型：1.销售订单 2.销退单
export enum OrderTypeEn {
  SALE_ORDER = 1,
  RETURN_ORDER = 2,
}
export enum OrderTypeEnName {
  SALE_ORDER = 1,
  RETURN_ORDER = 2,
}

//顺加方式
export enum PricingMethod {
  BATCH_COST = 1,
  INVENTORY_COST = 2,
  SELLING_PRICE = 3,
}
export enum PricingMethodName {
  BATCH_COST = '批次成本',
  INVENTORY_COST = '存货成本',
  SELLING_PRICE = '销售价格',
}
/**
 * 发货通知单-行状态
 * 行状态：1-待发货, 2-部分发货, 3-已发货 4-已关闭
 */
export enum RowStatus {
  WAIT_FOR_SHIPMENT = 1,
  PARTIAL_SHIPMENT = 2,
  SHIPPED = 3,
  CLOSED = 4,
}
export enum RowStatusName {
  WAIT_FOR_SHIPMENT = '待发货',
  PARTIAL_SHIPMENT = '部分发货',
  SHIPPED = '已发货',
  CLOSED = '已关闭',
}
/**
 *  功能：发货通知单行状态颜色(1-blue、2-orange、3-green、4-red)
 */
export enum RowStatusColor {
  WAIT_FOR_SHIPMENT = 'blue',
  PARTIAL_SHIPMENT = 'orange',
  SHIPPED = 'green',
  CLOSED = 'red',
}
/**
 * 收货通知单-行状态
 * 行状态：1-待收货, 2-部分收货, 3-已收货 4-已关闭
 */
export enum ReceivingRowStatus {
  WAIT_FOR_RECEIVING = 1,
  PARTIAL_RECEIVING = 2,
  SHIPPED = 3,
  CLOSED = 4,
}
export enum ReceivingRowStatusName {
  WAIT_FOR_RECEIVING = '待收货',
  PARTIAL_RECEIVING = '部分收货',
  SHIPPED = '已收货',
  CLOSED = '已关闭',
}
/**
 *  功能：收货通知单行状态颜色(1-blue、2-orange、3-green、4-red)
 */
export enum ReceivingRowStatusColor {
  WAIT_FOR_RECEIVING = 'blue',
  PARTIAL_RECEIVING = 'orange',
  SHIPPED = 'green',
  CLOSED = 'red',
}

/**
 * 承担方 1-我方 2-对方
 */
export enum UndertakerType {
  SELF = 1,
  COUNTERPART,
}
export enum UndertakerTypeName {
  SELF = '我方承担',
  COUNTERPART = '对方承担',
}

/**
 * 销售单据类型(1-标准订单(默认销售订单)、2-直发订单、3-调剂订单、4-调价订单、5-代发订单、6-直发预收订单、7-发退广播订单)
 */
export enum saleOrderType {
  STANDARD_ORDER = 1,
  DIRECT_ORDERS,
  TRANSFER_ORDERS,
  PRICE_ADJUSTMENT_ORDERS,
  DROPSHIPPING_ORDERS,
  DRRECT_DELIVERY_ORDERS,
  REJECT_THE_BROADCAST_ORDER,
}
export enum saleOrderTypeName {
  STANDARD_ORDER = '标准订单',
  DIRECT_ORDERS = '直发订单',
  TRANSFER_ORDERS = '调剂订单',
  PRICE_ADJUSTMENT_ORDERS = '调价订单',
  DROPSHIPPING_ORDERS = '代发订单',
  DRRECT_DELIVERY_ORDERS = '直发预收订单',
  REJECT_THE_BROADCAST_ORDER = '发退广播订单',
}

/**是否组合品种 */
export enum ifAssemblyType {
  是 = 0,
  否 = 1,
}
export const ifAssemblyStatus: SelectTypeTm[] = enumToListV(ifAssemblyType)

/**
 * 销售单据类型
 * 1-标准订单(默认销售订单)、2-直发订单、3-调剂订单、4-调价订单、5-代发订单、6-直发预收订单、7-发退广播订单
 */
export enum SalesOrderType {
  STANDARD_ORDER = 1,
  DIRECT_ORDER = 2,
  TRANSFER_ORDER = 3,
  PRICE_ORDER = 4,
  AGENT_ORDER = 5,
  DIRECT_PREPAID_ORDER = 6,
  BROADCAST_ORDER = 7,
}
export enum SalesOrderTypeName {
  STANDARD_ORDER = '标准订单',
  DIRECT_ORDER = '直发订单',
  TRANSFER_ORDER = '调剂订单',
  PRICE_ORDER = '调价订单',
  AGENT_ORDER = '代发订单',
  DIRECT_PREPAID_ORDER = '直发预收订单',
  BROADCAST_ORDER = '发退广播订单',
}
